import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';
import { EnergyStar } from 'src/app/services/power/energy-star/energy-star.service';
import { ISectionPresenter } from '../../../models/section-presenter';

@Injectable({
	providedIn: 'root',
})
export class EnergyStarSection implements ISectionPresenter {
	constructor(private energyStar: EnergyStar, private featureToggle: FeatureToggleService) {}

	public async isVisible(): Promise<boolean> {
		const isFeatureToggleEnabled = this.isFeatureToggleEnabled();
		const isCapable = await this.energyStar.getCapability();
		let isVisible = false;

		if (isFeatureToggleEnabled) {
			isVisible = isCapable && isFeatureToggleEnabled;
		}

		return Promise.resolve(isVisible);
	}

	public isFeatureToggleEnabled(): boolean {
		return this.featureToggle.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.EnergyStar
		);
	}
}
